var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"spinner",class:{inline: _vm.inline, main : !_vm.inline, 'spinner-small' : _vm.small}},[_c('img',{attrs:{"src":_vm.spinnerSrc}}),(_vm.msg)?_c('div',{staticClass:"msg"},[_c('div',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }